import React, { useLayoutEffect, useRef, useState } from "react";

interface ExpandableTextProps {
    text: string;
    showMoreLabel: string;
    showLessLabel: string;
    lines?: number;
    className?: string;
}

// Text clamped to N lines with a "show more / show less" toggle (only when it overflows).
const ExpandableText = ({ text, showMoreLabel, showLessLabel, lines = 3, className = "" }: ExpandableTextProps) => {
    const ref = useRef<HTMLParagraphElement>(null);
    const [expanded, setExpanded] = useState(false);
    const [overflowing, setOverflowing] = useState(false);

    useLayoutEffect(() => { setExpanded(false); }, [text]);

    useLayoutEffect(() => {
        const el = ref.current;
        if (!el || expanded) return;
        setOverflowing(el.scrollHeight > el.clientHeight + 1);
    }, [text, expanded]);

    return (
        <div className={`gip-expandable ${className}`}>
            <p
                ref={ref}
                className="gip-expandable-text"
                style={expanded ? undefined : { WebkitLineClamp: lines }}
                data-clamped={!expanded}
            >
                {text}
            </p>
            {(overflowing || expanded) && (
                <button type="button" className="gip-see-more-btn" onClick={() => setExpanded(v => !v)}>
                    {expanded ? showLessLabel : showMoreLabel}
                </button>
            )}
        </div>
    );
};

export default ExpandableText;
